import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  footerLinks = [
    {
      label: 'About WTW',
      url: 'https://www.wtwco.com/en-us/about-us/overview',
      ariaLabel: 'About WTW'
    },
    {
      label: 'Privacy Notice',
      url: 'https://www.wtwco.com/en-us/notices/global-website-privacy-notice',
      ariaLabel: 'Privacy Notice'
    }
  ];
}
